// extracted by mini-css-extract-plugin
module.exports = {"ProductFeature":"ProductFeature","ProductFeature--small":"ProductFeature--small","ProductFeature__Graphic":"ProductFeature__Graphic","Flex":"Flex"};